import React, {Component,PureComponent} from 'react';
import {Field, reduxForm, FieldArray} from 'redux-form'
import { Upload, Button, Icon, message } from 'antd';
import reqwest from 'reqwest';
import {RTLCol, RTLUpload,RTLButton} from "../RTLKit";
import {API_FETCH} from '../../services/FetchService';
import {commonConstants} from "../../actions/commonActions";
import appConfig from '../../config'

const url = appConfig.pubHost+'/static/'
const mapDispatchToProps = dispatch => ({
    setImageUrl: (imageUrl) => {
        return(dispatch({type: commonConstants.COMMON_IMAGE_UTL, data: imageUrl}))
    },

});

const mapStateToProps = state => {
    return {
        imageUrl : state.common.imageUrl,
    }
};


class uploadFile extends Component {

    constructor(props) {
        super(props);
    }
    state = {
        fileList: [],
        uploading: false,
        previewImage:''
    };

    removePic(e){
        this.setState({fileList: '',imageUrl:'',previewImage:''})
    }


    handleUpload = (e) => {
        const {fileList} = this.state;
        e.preventDefault();
        const formData = new FormData();
        this.setState({
            uploading: true,
        });
        formData.append('image',fileList[0]);
        let config = {
            'content-type': 'multipart/form-data',
            'authorization': "Bearer "+this.props.token
        };
        API_FETCH.post('upload', formData, config).then(res => {
            if(res.status === 201) {
                let imgPreview = url+res.data.filename
                this.setState({
                    fileList: [],
                    uploading: false,
                    previewImage:imgPreview,
                    imageUrl:res.data.filename
                });
                console.log('upload successfully.');
            }
            else{
                this.setState({
                    uploading: false,
                });
                console.log('upload failed.');
            }
        }).catch(error => {
            console.log(error)
        });
    };

    render() {
        const {
            input,
            label,
            defaultValue,
            help,
            token,
            meta: {touched, error, warning},
        } = this.props


        const { uploading, fileList, imageUrl,previewImage } = this.state;
        const props = {
            onRemove: file => {
                this.setState(state => {
                    const index = state.fileList.indexOf(file);
                    const newFileList = state.fileList.slice();
                    newFileList.splice(index, 1);
                    return {
                        fileList: newFileList,
                    };
                });
            },
            beforeUpload: file => {
                this.setState(state => ({
                    fileList: [...state.fileList, file],
                }));
                return false;
            },
            fileList,
        };

        // const handleChange = info => {
        //     if (info.file.status === 'uploading') {
        //         this.setState({ loading: true });
        //         return;
        //     }
        //     if (info.file.status === 'done') {
        //         // Get this url from response in real world.
        //         this.getBase64(info.file.originFileObj, imageUrl =>
        //             this.setState({
        //                 imageUrl,
        //                 loading: false,
        //             }),
        //         );
        //     }
        //
        // };

        const uploadButton = (
            <div>
                <Icon type={this.state.loading ? 'loading' : 'plus'} />
            </div>
        );

        input.onChange(imageUrl);

        return (
            <RTLCol span={24}>
                <RTLCol className="formLabel" md={label ? 5 : 0} sm={24}>
                    {label ? <label>{label} : </label> : null}
                </RTLCol>
                <RTLCol md={label ? 15 : 19} sm={24}>
                    <RTLCol md={24} sm={24}>
                        <RTLCol md={8}>
                            <RTLUpload
                                {...props}
                                listType="picture-card"
                                className="avatar-uploader"
                                showUploadList={false}
                                value={input.input}
                            >
                                {previewImage || defaultValue ? <img src={previewImage || url+defaultValue} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                            </RTLUpload>
                            <Icon type="close-circle" style={{position:"absolute",top:'-5px',right:0,color:'red',fontSize:20}} onClick={this.removePic.bind(this)} />
                        </RTLCol>
                        <RTLCol md={4}>
                            <RTLButton
                                type="primary"
                                onClick={this.handleUpload}
                                disabled={fileList.length === 0}
                                loading={uploading}
                                style={{ position:'relative',top:70 }}
                            >
                                {uploading ? 'در حال بارگزاری' : 'بارگزاری'}
                            </RTLButton>
                        </RTLCol>
                    </RTLCol>
                    {help ?
                        <span className="settingsHelp">
                                {help}
                            </span>
                        : null}
                </RTLCol>
                <RTLCol md={3} sm={24}>
                    {touched &&
                    ((error && <span className="errorMsg">{error}</span>) ||
                        (warning && <span className="warningMsg">{warning}</span>))}
                </RTLCol>
            </RTLCol>
        );
    }
}

export default uploadFile;